/**
 * Reports → Call Reports → Outbound Call Report.
 *
 * The mirror of the inbound report: connect rate, failure breakdown and the
 * dialler's abandon rate, aggregated per interval × campaign × agent.
 */
import type { JSX } from 'react'
import { PhoneForwarded } from 'lucide-react'

import OutboundCallAnalytics from '../../../components/reports/calls/OutboundCallAnalytics.js'
import {
  OUTBOUND_CALL_COLUMNS,
  OUTBOUND_CALL_REPORT_ID,
} from '../../../components/reports/calls/columns.js'
import CallReportPage from './CallReportPage.js'

export default function OutboundCallReportPage(): JSX.Element {
  return (
    <CallReportPage
      Icon={PhoneForwarded}
      title="Outbound Call Report"
      intro="Outbound attempts per interval — connect rate, failures, and what the dialler dropped"
      unit="interval"
      path="/reports/calls/outbound"
      reportId={OUTBOUND_CALL_REPORT_ID}
      catalog={OUTBOUND_CALL_COLUMNS}
      fields={['campaigns', 'agents', 'queues', 'trunks']}
      windowNote="The window is on the time each call started. Outbound calls only."
      defaultInterval="60m"
      searchPlaceholder="Search intervals…"
      renderAnalytics={(rows) => <OutboundCallAnalytics rows={rows} />}
      emptyDescription="Choose a start date, an end date and an interval in Filters, then run the report."
      noResultsTitle="No outbound calls in this window"
      noResultsDescription="No outbound call was placed in the selected scope. Try widening the window, or clearing the campaign and agent filters."
    />
  )
}
